import { apiPostAuth, apiGetAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_FORMS } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  forms_list: { 
    isLoading: false,
    data: {}
  },
  detail_forms: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  detail_modal_preview: {},
  meta_filter: {
    order_by: 'created_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_FORMS_LIST": (state, payload) => {
    state.forms_list = payload
  },
  "SET_DETAIL_FORMS": (state, payload) => {
    state.detail_forms = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getFormsList(context, payload) {
    try {
      context.commit('SET_FORMS_LIST', { isLoading: true })
      const response = await apiGetAuth(API_FORMS.LIST, payload)
      context.commit('SET_FORMS_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_FORMS_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getDetailForms (context, payload) {
    try {
      context.commit('SET_DETAIL_FORMS', { isLoading: true })
      const response = await apiGetAuth(API_FORMS.BY_ID(payload))
      context.commit('SET_DETAIL_FORMS', {
        isLoading: false,
        data: response.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_FORMS', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async createForm (context, payload) {
    try {
      const response = await apiPostAuth(API_FORMS.CREATE_FORMS, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateForms (context, payload) {
    try {
      const response = await apiPutAuth(API_FORMS.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteForms (context, payload) {
    try {
      const response = await apiDeleteAuth(API_FORMS.BY_ID(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_forms_list: state => {
    return state.forms_list
  },
  get_detail_forms: state => {
    return state.detail_forms
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
